import { useMutation } from '@tanstack/react-query';
import { postUserConnect } from 'api/resources/authorization';
import type { TUserConnectData } from 'api/resources/authorization';

export const usePostUserConnect = () => {
	return useMutation((params: TUserConnectData) => postUserConnect(params));
};
